import React, { createContext, useState } from 'react';
import axios from 'axios';
import { URL_API } from '../utils/globalConfig';
import { logError } from '../components/Utils/FormatData';

export const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
    const [unreadRequestPassMessages, setUnreadRequestPassMessages] = useState(false);
    const [unreadPlanificationMessages, setUnreadPlanificationMessages] = useState(false);

    const markMessagesAsRead = (user) => {
        if (!user) return;
        axios({
            method: 'get',
            url: URL_API + '/messagerie/dossier-messages-non-lus',
            params: { requestPassId: 0, userAction: user.user_id },
        })
        .then((response) => {
            setUnreadRequestPassMessages(response.data);
        })
        .catch((error) => {
            logError(alert, error);
        });

        axios({
            method: 'get',
            url: URL_API + '/messagerie/planification-messages-non-lus',
            params: { planificationId: 0, userAction: user.user_id },
        })
        .then((response) => {
            setUnreadPlanificationMessages(response.data);
        })
        .catch((error) => {
            logError(alert, error);
        });
    };


    return (
        <MessageContext.Provider value={{
            unreadRequestPassMessages,
            unreadPlanificationMessages,
            markMessagesAsRead,
            setUnreadRequestPassMessages,
            setUnreadPlanificationMessages,
        }}>
            {children}
        </MessageContext.Provider>
    );
};
